export default "__VITE_ASSET__CWt3BLwi__"